import { render, staticRenderFns } from "./ExpenseRecoveryAccountDetails.vue?vue&type=template&id=50498c26&scoped=true"
import script from "./ExpenseRecoveryAccountDetails.vue?vue&type=script&lang=js"
export * from "./ExpenseRecoveryAccountDetails.vue?vue&type=script&lang=js"
import style0 from "./ExpenseRecoveryAccountDetails.vue?vue&type=style&index=0&id=50498c26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50498c26",
  null
  
)

export default component.exports